import DocumentStatisticsService from '../services/DocumentStatisticsService'

export default {
  namespaced: true,
  state: () => ({
    totalDocumentosPendientes: 0
  }),
  mutations: {
    SET_TOTAL_DOCUMENTOS_PENDIENTES(state, total) {
      state.totalDocumentosPendientes = total
    }
  },
  actions: {
    getTotalDocumentsPending: async function({ commit }) {
      const service = new DocumentStatisticsService()

      try {
        const { data } = await service.getTotalDocumentsPending()
        const totalDocumentosPendientes = data.data.totalDocumentosPendientes

        commit('SET_TOTAL_DOCUMENTOS_PENDIENTES', totalDocumentosPendientes)

        return {
          success: true,
          data: totalDocumentosPendientes
        }
      } catch (err) {
        return {
          success: false,
          error: err
        }
      }
    }
  },
  getters: {
    totalDocumentosPendientes(state) {
      return state.totalDocumentosPendientes
    }
  }
}
